module.exports = __webpack_public_path__ + "img/customer-a-030.846b91e2.png";